import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const TruckSmall = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M12.1 4.18c0-.484-.561-.847-.998-.847H.873c-.499 0-.873.363-.873.848l.042 9.642c0 .484.395.806.894.806H2.12c0 1.03.756 2.038 1.879 2.038s2.07-1.009 2.07-2.038h7.86c0 1.03.997 2.038 2.12 2.038s2.079-1.009 2.079-2.038h1.247c.437 0 .624-.322.624-.806v-2.058c0-.484 0-.767-1.06-.767H17.92L12.1 5.35zm-1.248 3.995h1.664l2.91 2.823h-4.574z" }) }));
});
TruckSmall.displayName = 'TruckSmall';
TruckSmall.__iconComponentType = 'standard';
export default TruckSmall;
//# sourceMappingURL=TruckSmall.js.map